import React, { Component } from "react";
import Table from "../component/Table";
import API from "../../apiService";
import Alert, { confirmedAlert, toast } from "../component/Alert";
import ModalAddUser from "./modalAddUser";

export default class Role extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datas: [],
      isLoading: true,
      modalShow: false,
      user: JSON.parse(localStorage.getItem("userData")),
      roleData: null,
      search: "",
      searched : [],
      userPcare:[]
    };
  }

  componentDidMount() {
    this.getRole();
  }

  getRole = async () => {
    const res = await API.get(
      "config/role/read"
    );
    if (res.code === 200) {
      this.setState({
        datas: res.data,
      });
    }
  };

  deleteRole = async (data) => {
    confirmedAlert('Konfirmasi', "Yakin mau menghapus " + data.name + "?", async () => {
      const res = await API.delete(`config/role/delete/${data.id}`);
      if (res.code === 200) {
        Alert("success", "Berhasil menghapus " + data.name);
        this.getRole();
      }
    })
  };

  create_button(datas) {
    return (
      <div>
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => {
            this.setState({ roleData: datas }, () => {
                this.setState({ modalShow: true })
            })
          }}
        >
          edit
        </button>
        <button
          className={`btn btn-sm btn-outline-danger`}
          onClick={() => this.deleteRole(datas)}
        >
          Hapus
        </button>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col">
            <div className="card">
              <div className="card-header row">
                <div>
                  <button
                    type="button"
                    className="btn btn-primary  align-items-right"
                    data-toggle="collapse"
                    data-target="#collapsePreview"
                    aria-expanded="false"
                    aria-controls="collapsePreview"
                    onClick={() => this.setState({ modalShow: true })}
                  >
                    <span className="btn-inner--icon">
                      <i className="ni ni-fat-add"/>
                    </span>
                    <span className="btn-inner--text"> Add</span>
                  </button>
                </div>
              </div>
              <div className="border-0" />
              <Table
                headers={[
                  "No",
                  "name",
                  "description",
                  "Aksi",
                ]}
                data={this.state.datas}
                columnMapper={(datas, key) => [
                  datas.name,
                  datas.description,
                  this.create_button(datas),
                ]}
                pagination={true}
              />
            </div>
          </div>
        </div>
        <ModalAddUser
          getrole={this.getRole}
          roledata={this.state.roleData}
          show={this.state.modalShow}
          upcare = {this.state.userPcare}
          onHide={() => this.setState({ modalShow: false })}
        />
      </div>
    );
  }
}
